export function clearAuth() {
  localStorage.removeItem("auth");
}

function decodeJwtPayload(token) {
  try {
    const payload = token.split('.')[1];
    if (!payload) return null;

    const base64 = payload.replace(/-/g, '+').replace(/_/g, '/');
    const padded = base64.padEnd(Math.ceil(base64.length / 4) * 4, '=');
    return JSON.parse(atob(padded));
  } catch (e) {
    console.error("Ошибка чтения JWT:", e);
    return null;
  }
}

export function getStoredAuth() {
  try {
    return JSON.parse(localStorage.getItem("auth") || "{}");
  } catch (e) {
    console.error("Ошибка чтения auth:", e);
    return {};
  }
}

export function getStoredUser() {
  const { token, role, username } = getStoredAuth();
  if (!token) return null;

  const payload = decodeJwtPayload(token);
  if (!payload || (payload.exp && payload.exp * 1000 <= Date.now())) {
    clearAuth();
    return null;
  }

  const normalizedRole = role
    ? (role.startsWith('ROLE_') ? role : `ROLE_${role}`)
    : null;

  return {
    username: payload.sub || username || '',
    roles: normalizedRole ? [normalizedRole] : [],
  };
}

export async function fetchCurrentUser() {
  const headers = getAuthHeader();
  if (!headers.Authorization) return null;

  try {
    const res = await fetch('/api/auth/me', { headers });
    if (!res.ok) throw new Error('Not authenticated');
    return await res.json();
  } catch (e) {
    console.error(e);
    return null;
  }
}

export function setToken(token, role, username = '') {
  localStorage.setItem("auth", JSON.stringify({ token, role, username }));
}

export function getAuthHeader() {
  const { token } = getStoredAuth();
  return token ? { Authorization: `Bearer ${token}` } : {};
}
